
const digest = '47f695e9ae4caf02b01511ea0607d5007140b7f421e6e68746dbb34bc11700a4';
const css = `._searchComponent_1syzi_1 {
  overflow: hidden;
}

._emoji_1syzi_5 {
  font-size: 16px;
}

._shortcode_1syzi_9 {
  position: relative;
  top: -1px;
  margin-left: 5px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"searchComponent":"_searchComponent_1syzi_1","emoji":"_emoji_1syzi_5","shortcode":"_shortcode_1syzi_9"};
export { css, digest };
  